var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{scroller: !_vm.data.simple}},[_c('figure',[_vm._t("figure",null,{"ratio":_vm.ratio,"data":_vm.data})],2),_c('article')])}
var staticRenderFns = []

export { render, staticRenderFns }